export default __webpack_public_path__ + "static/media/Crossroads.a06c7576.jpg";